import React, {Component} from 'react';
import {showSnackbar} from "../../Redux/actions/snackbar";
import {hideLoadingBar, showLoadingBar} from "../../Redux/actions/loading";
import {connect} from "react-redux";
import {PGService} from "../../Remote/PowerGym";
import List from '@material-ui/core/List';
import DoneIcon from '@material-ui/icons/Done';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import {withNamespaces} from 'react-i18next';
import {withStyles} from '@material-ui/core/styles';
import {Formatters} from "../../Utils/Formatters";
import RefreshIcon from '@material-ui/icons/Refresh';
import dayjs from 'dayjs';


const ExpansionPanel = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
    root: {
        backgroundColor: 'rgba(0, 0, 0, .03)',
        borderBottom: '1px solid rgba(0, 0, 0, .125)',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles(theme => ({
    root: {
        padding: '2',
    },
}))(MuiExpansionPanelDetails);

class ScheduleList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            schedules: null,
            onlineSchedules: [],
            expanded: null
        }
    }

    loadSchedules = () => {
        this.props.showLoadingBar();

        PGService.getOnlineBookingsPerSchedule().then(response => {
            this.setState({
                onlineSchedules: response.data,
            });
            this.props.hideLoadingBar();
        });
    };

    componentDidMount() {
       this.loadSchedules();
    }

    handleChange = panel => (event, newExpanded) => {
        this.setState({
            expanded: newExpanded ? panel : false
        });
    };

    render() {
        return <>
            <h2>Turnos en Vivo</h2>
            <Fab variant="extended" color="primary" aria-label="Recargar" className="plusBtn" onClick={this.loadSchedules}>
                <RefreshIcon/>
                Recargar
            </Fab>
            <Typography>Se muestran los turnos con un margen de 30 minutos.</Typography>
            <Typography>Los socios marcados con <DoneIcon /> han registrado una asistencia hoy.</Typography>
            <br/>
            {this.state.onlineSchedules.map(schedule => (
                <ExpansionPanel square
                                key={schedule.id}
                                expanded={this.state.expanded === schedule.id}
                                onChange={this.handleChange(schedule.id)}>
                    <ExpansionPanelSummary aria-controls={`panel${schedule.id}d-content`}
                                           id={`panel${schedule.id}d-header`}>
                        <Typography>
                            <strong>{schedule.name} ({schedule.users.length || 0}/{schedule.limit_count})</strong>
                            <br/>
                            {Formatters.formatTime(schedule.start_at)} a {Formatters.formatTime(schedule.end_at)}
                        </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <List>
                            {schedule.users.map(user => (
                                <ListItem key={`item-${schedule.schedule_id}-${schedule.id}-${user.id}`}>
                                    <ListItemText primary={`${user.first_name} ${user.last_name}`}/>
                                    {user.last_visit_at && dayjs(user.last_visit_at).isSame(dayjs(), 'day') &&
                                    <Tooltip title={`Ha registrado una asistencia hoy a las ${dayjs(user.last_visit_at).format('HH:mm')}`} placement="right">
                                        <DoneIcon />
                                    </Tooltip>
                                    }
                                </ListItem>
                            ))}
                        </List>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            ))}
        </>
    }

}


const mapStateToProps = (state) => ({
    loading: state.loading
});

const mapDispatchToProps = dispatch => ({
    showLoadingBar: () => dispatch(showLoadingBar()),
    hideLoadingBar: () => dispatch(hideLoadingBar()),
    showSnackbar: (message) => dispatch(showSnackbar(message))
});

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(ScheduleList));
